import Services from './base-services'

const service = new Services('linguisticVariable')

export default {
    findAll() {
        return service.get(`findAll`)
    },
    getVariablesByBookId( bookId: any ) {
        return service.get(`getVariablesByBookId?bookId=${bookId}`)
    }
}
